<template>
<div
  :class="`wallet-workpackage-status ${color} ${color.includes('lighten') || color.includes('darken')? '':'lighten-1'}`"
  :style="`
  ${justify_content?`justify-content: ${justify_content};`:''}
  ${textcolor?`color: ${textcolor};`:'color: black;'}
  `"
  >
  <slot/>
</div>
</template>
<script>
export default {
  props: ['color', 'justify_content', 'cursor', 'textcolor'],
  data: () => ({

  }),
}
</script>
<style>
.wallet-workpackage-status {
  display: flex;
  width: 100%;
  height: 43px;
  font-size: 14px;
  line-height: 14px;
  align-items: flex-start;
  justify-content: space-around;
  padding-top: 3px;
  cursor: pointer;
}
</style>
